const types = ["image", "video", "audio", "card", "wait", "text"];

export default ({ data, functions }) => {
  const { dispatch, parsedMessageReceived } = functions;
  const { message, visible } = data;
  let dataActions = false;

  if (!visible) {
    return;
  }

  if (Array.isArray(message)) {
    dataActions = message;
  } else if (typeof message === "object") {
    const { type, options } = message;

    if (Array.isArray(options) && options.length > 0) {
      dataActions = {
        ...message,
        options,
        type: "choice",
        options_type: "suggested_replies",
      };
    } else if (types.includes(type)) {
      dataActions = {
        ...message,
      };
    }
  } else if (typeof message === "string") {
    const messageWithTrim = message && message.trim();

    dataActions = {
      type: "text",
      text: messageWithTrim,
    };
  }
  if (dataActions) {
    const createMessage = () =>
      JSON.stringify({
        message: {
          from: "bot",
          actions: Array.isArray(dataActions)
            ? dataActions
            : [
                {
                  ...dataActions,
                },
              ],
        },
      });

    dispatch(parsedMessageReceived(createMessage()));
  }
};
